/**
 * Returns a collection with filtered unique items.
 * Items are kept unique within whole collection.
 *
 * @param {array} collection - a collection of object with items property, which is a collection too.
 * @param {number} itemCount - number of unique items to filter out.
 * @returns {array}
 */
export function filterCollectionUniqueItems(collection, itemCount) {
    const seenItemIds = [];

    return collection.map(object => {
        let seenItemCount = 0;

        return {
            ...object,
            items: object.items.filter(item => {
                if (seenItemIds.includes(item.id) || seenItemCount >= itemCount) {
                    return false;
                } else {
                    seenItemIds.push(item.id);
                    seenItemCount++;

                    return true;
                }
            })
        };
    });
}



// WEBPACK FOOTER //
// ./assets/js/global/utils/filterCollectionUniqueItems.es.js